import React, { useEffect, useState } from 'react'
import logo from '../../assets/Gratitude.png'
import Backdrop from '@material-ui/core/Backdrop'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import axios from 'axios'
import Swal from 'sweetalert2'
import Mapp from '../Maps'

import './styles.css'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const url = process.env.BASE_URL || 'https://gratitudemap-back.herokuapp.com/message/'

function Main () {
  const [location, setLocation] = useState(null)
  const [control, setControl] = useState('flex')
  const [flag, setFlag] = useState('none')

  function changePage () {
    if (control === 'flex') {
      setControl('none')
      setFlag('flex')
    } else {
      setControl('flex')
      setFlag('none')
    }
  }
  /**
   * Função para otimizar a captura do texto
   */

  async function getText () {
    const mes = await document.getElementById('message')
    if (!location) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'We were unable to obtain your location',
        showConfirmButton: false,
        timer: 2000,
        background: '#FDFCDC'
      })
    } else if (!mes.value) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Empty message',
        showConfirmButton: false,
        timer: 2000,
        background: '#FDFCDC'

      })
    } else {
      axios.post(url, {
        message: mes.value,
        coordinates: [location.latitude, location.longitude]
      }).then(e => gotMapp()).catch(err => console.log(err))
    }
  }
  /**
   * Função de transição entre telas
   */

  async function gotMapp () {
    await Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Message sent successfully',
      showConfirmButton: false,
      timer: 2000,
      background: '#FDFCDC'
    })

    changePage()
  }

  useEffect(() => {
    console.log('Run')
    navigator.geolocation.getCurrentPosition((e) => {
      if (e) {
        setLocation({
          latitude: e.coords.latitude,
          longitude: e.coords.longitude
        })
      } else {
        return setLocation(null)
      }
    })
  }, [flag])

  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <div className='App' style={{ display: control }}>
        <header className='App-header'>
          <img id='logo' src={logo} alt='Logo' />
          <div className='borda'>
            <TextField
              id='message'
              label='Your Message'
              variant='outlined'
              color='primary'
            />
          </div>
          <Button
            id='button'
            variant='contained'
            color='#CC59D2'
            onClick={async () => {
              getText()
            }}
          >
            Be grateful
          </Button>
          <Button
            id='button'
            variant='outline'
            color='#FFF'
            onClick={changePage}
            style={{
              color: 'white'
            }}
          >
            Show Map
          </Button>
          <Backdrop
            className={classes.backdrop}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color='inherit' />
          </Backdrop>
          <a href='http://ukecode.org/' className='site'>
            @ {new Date().getFullYear()} ukecode.org
          </a>
        </header>
      </div>
      <Mapp visible={flag}> </Mapp>
    </>
  )
}

export default Main
